import type { BadgeKind } from '@components/SitemapReport/types'

const BadgeHints: Record<BadgeKind, string> = {
  blocked:
    'The site restricted access to our crawler. The page may still open in your browser.',
  broken: 'This page returned an error when we checked it.',
  missing_description:
    'This page has no meta description to describe it in search results.',
  missing_h1: 'We couldn’t find a main heading (H1) on this page.',
  missing_title:
    'This page has no title for the browser tab or search results.',
  new: 'This page was found in the latest crawl but not the previous one.',
  nofollow:
    'We skipped this page because a link told our crawler not to follow it.',
  noindex: 'This page asks search engines not to show it in search results.',
  redirect: 'This link redirects to another address.',
  removed: 'This page wasn’t found in the latest crawl. It may still exist.',
  robots: 'We skipped this page following the site’s robots.txt rules.',
  skipped:
    'This page was skipped during the crawl, so we couldn’t check its content.',
  updated:
    'Its title, H1, description, status, noindex or canonical changed since the previous crawl.',
}

const BlockedHints: Partial<Record<number, string>> = {
  401: 'The site requires sign-in before our crawler can check this page.',
  403: 'The site denied our crawler access. The page may still open in your browser.',
  408: 'The site reported that the request timed out. Try checking this page again later.',
  429: 'The site received too many requests. Try checking this page again later.',
}

export const getBadgeHint = (
  kind: BadgeKind,
  status: number | null
): string => {
  if (kind === 'blocked' && status !== null) {
    return BlockedHints[status] ?? BadgeHints.blocked
  }

  if (kind === 'broken') {
    if (status === null) {
      return 'We couldn’t get a response from this page.'
    }

    if (status === 404) {
      return 'Your site may link to this missing page. Update or remove the link.'
    }

    if (status === 410) {
      return 'The site says this page is no longer available. Update or remove links to it.'
    }

    if (status >= 500) {
      return 'The site’s server couldn’t load this page. Try checking it again later.'
    }
  }

  return BadgeHints[kind]
}
